import { useQuery } from 'react-query';
import QUERY_CACHE_KEY from '@src/constants/QueryCacheKey';

function usePostQuery(id, options) {
  return useQuery(QUERY_CACHE_KEY.post(id), { ...options, staleTime: 10 * 60 * 1000 });
}

export default usePostQuery;
